import "./index.scss";

export type TitleCoverColor = "title-color" | "work-color";

interface ITitleCoverProps {
    /**
     * The url of cover
     */
    coverUrl?: string;
    /**
     * The string title to parse (First letter in CAPS) if there's no cover
     */
    title: string;
    /**
     * CSS properties
     */
    style?: React.CSSProperties;
    /**
     * Id of the image, generally used to get HTML element for E2E tests on Cypress
     */
    id?: string;
    /**
     * When false, missing covers render as a gray block (no initial).
     */
    showPlaceholderLetter?: boolean;
    /**
     * Placeholder color: pink for a title, gray for a work.
     */
    color?: TitleCoverColor;
    /**
     * Visual variant. "framework" tints the fallback for contrat cadre badges.
     */
    variant?: "title" | "framework";
}

/**
 * This component display the Cover of a title with and aspect ratio of 3:4 and object fit contain
 * @param {string} coverUrl The link of the image cover
 * @param {string} title The title to display the first letters if there's no cover
 * @param {object} style Style component
 */

const TitleCover = ({
    coverUrl,
    title,
    style,
    id,
    showPlaceholderLetter = true,
    color = "title-color",
    variant = "title",
}: ITitleCoverProps) => {
    const placeholderClass = [
        "title-no-cover",
        "aspect-3/4",
        "min-w-8",
        variant === "framework" ? "title-no-cover--framework" : `title-no-cover--${color}`,
        !showPlaceholderLetter ? "title-no-cover--empty" : "",
    ]
        .filter(Boolean)
        .join(" ");

    return coverUrl?.trim() ? (
        <div className="title-cover aspect-3/4 min-w-8">
            <img src={coverUrl} style={style} id={id} />
        </div>
    ) : (
        <div className={placeholderClass} style={style}>
            {showPlaceholderLetter && title ? title.slice(0, 1).toLocaleUpperCase() : ""}
        </div>
    );
};

export default TitleCover;
